import { GenericMoleculeOverviewRowPanelDashboardComponent } from '../abstract';

// tslint:disable-next-line:max-line-length
export class MoleculeOverviewRowPanelDashboardWebspacesComponent extends GenericMoleculeOverviewRowPanelDashboardComponent {
    public template = require('./dashboard-webspaces.html');
    protected type = 'webspaces';
}
